import { render, staticRenderFns } from "./ui-date-picker.vue?vue&type=template&id=0c1fa9ec&"
import script from "./ui-date-picker.vue?vue&type=script&lang=ts&"
export * from "./ui-date-picker.vue?vue&type=script&lang=ts&"
import style0 from "./ui-date-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports